import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
import app from './modules/app';
import session from './modules/session';
import account from './modules/account';
import user from './modules/user';
import role from './modules/role';
import tenant from './modules/tenant';
import district from './modules/district';
import customer from './modules/customer';
import packageType from './modules/packageType';
import smsSetting from './modules/smsSetting';
import emailSetting from './modules/emailSetting';
import paymentSetting from './modules/paymentSetting';
import mapSetting from './modules/mapSetting';
import flight from './modules/flight';

import country from './modules/country';
import city from './modules/city';
import airport from './modules/airport';
import airlineCompany from './modules/airlineCompany';
import aircraft from './modules/aircraft';
import flightProvider from './modules/flightProvider';
import flightClass from './modules/flightClass';
import flightSegment from './modules/flightSegment';
import airportTerminal from './modules/airportTerminal';
import flightSaleChannel from './modules/flightSaleChannel';
import flightRoute from './modules/flightRoute';
import agency from './modules/agency';
import exchangeRate from './modules/exchangeRate';
import currency from './modules/currency';
import reservation from './modules/reservation';
import flightPassengers from './modules/flightPassengers';
import webServiceMarkup from './modules/webServiceMarkup';
import auxiliaryService from './modules/auxiliaryService';
import bot from './modules/bot';


const store = new Vuex.Store({
  state: {
    //
  },
  mutations: {
    //
  },
  actions: {},
  modules: {
    app,
    session,
    account,
    user,
    role,
    tenant,
    district,
    customer,
    packageType,
    smsSetting,
    emailSetting,
    paymentSetting,
    mapSetting,
    flight,
    country,
    city,
    airport,
    airlineCompany,
    aircraft,
    flightProvider,
    flightClass,
    flightSegment,
    airportTerminal,
    flightSaleChannel,
    flightRoute,
    agency,
    exchangeRate,
    currency,
    reservation,
    flightPassengers,
    webServiceMarkup,
    auxiliaryService,
    bot,
  },
});

export default store;
